module.exports = __webpack_public_path__ + "img/finance-application-display-cjdr.02e9307e.jpg";